import React, { useMemo, useEffect, useState } from "react";
import Modal from "./Modal";

const LABEL_BY_FREQUENCY = {
  daily: "Günlük Rapor",
  weekly: "Haftalık Rapor",
  monthly: "Aylık Rapor",
};

const ReportPreviewModal = ({
  open,
  onClose,
  pdfBase64,
  frequency,
  reportType,
  dateRange,
  onConfirm,
  isSending,
}) => {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!open || !pdfBase64) {
      setBlobUrl(null);
      return undefined;
    }
    const byteChars = atob(pdfBase64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i += 1) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    setBlobUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [open, pdfBase64]);

  const title = useMemo(
    () => reportType || LABEL_BY_FREQUENCY[frequency] || "Rapor Önizleme",
    [reportType, frequency]
  );

  return (
    <Modal
      open={open}
      onClose={isSending ? () => {} : onClose}
      maxWidth="full"
      zIndex={10000}
    >
      <Modal.Header
        title={title}
        subtitle={dateRange || "Önizleme — maili göndermeden önce kontrol edin"}
        onClose={isSending ? () => {} : onClose}
      />
      <Modal.Body className="p-0 h-[70vh]">
        {blobUrl ? (
          <iframe
            src={blobUrl}
            title="Rapor Önizleme"
            className="w-full h-full border-0"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-500 text-sm">
            Önizleme yükleniyor...
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="flex justify-end gap-3">
        <button
          type="button"
          onClick={onClose}
          disabled={isSending}
          className="px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 disabled:opacity-50"
        >
          İptal
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={isSending || !blobUrl}
          className="px-5 py-2 bg-main text-white text-sm font-semibold rounded-lg hover:opacity-90 disabled:opacity-50"
        >
          {isSending ? "Gönderiliyor..." : "Maili Gönder"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportPreviewModal;
